import { DateTime } from 'luxon';
import { ActionTypes, ActionTypeDisplayNames } from 'src/app/models/api/playbooks/actions/actionTypes.enum';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { dateToUtcIsoString } from './datetime_utility';

export function isViolationTrigger(triggerType: TriggerTypes): boolean {
  return (
    triggerType === TriggerTypes.newViolationFound ||
    triggerType === TriggerTypes.newOrExistingViolationFound ||
    triggerType === TriggerTypes.existingViolationFound
  );
}

export function isResourceTrigger(triggerType: TriggerTypes): boolean {
  return (
    triggerType === TriggerTypes.newResourceFound ||
    triggerType === TriggerTypes.newOrExistingResourceFound ||
    triggerType === TriggerTypes.existingResourceFound
  );
}

export function isBrownfieldTrigger(triggerType: TriggerTypes): boolean {
  return (
    triggerType === TriggerTypes.existingResourceFound ||
    triggerType === TriggerTypes.existingViolationFound ||
    triggerType === TriggerTypes.newOrExistingResourceFound ||
    triggerType === TriggerTypes.newOrExistingViolationFound
  );
}

export function isFindingsTrigger(triggerType: TriggerTypes): boolean {
  return triggerType === TriggerTypes.newFindingFound;
}

export function isIssueTrigger(triggerType: TriggerTypes): boolean {
  return triggerType === TriggerTypes.newIssueFound;
}

export function serializeTriggerConfiguration(formValue: Record<string, unknown>): Record<string, unknown> {
  const configuration = { ...formValue };

  // List of date fields that need to be serialized
  const dateFields = [
    'resourceCreatedSince',
    'resourceCreatedUntil',
    'resourceFirstSeenSince',
    'resourceFirstSeenUntil',
    'resourceModifiedSince',
    'resourceModifiedUntil',
  ];

  // Convert Date objects and Luxon DateTime objects to ISO strings
  dateFields.forEach((field) => {
    const value = configuration[field];
    if (value) {
      // Check if it's a Luxon DateTime object
      if (DateTime.isDateTime(value)) {
        // Convert Luxon DateTime to JavaScript Date first, then to ISO string
        configuration[field] = dateToUtcIsoString(value.toJSDate());
      }
      // Check if it's a regular Date object
      else if (value instanceof Date) {
        configuration[field] = dateToUtcIsoString(value);
      }
    }
  });

  return configuration;
}

export function getActionTypeDisplayName(actionType: ActionTypes): string {
  return ActionTypeDisplayNames[actionType] || actionType;
}
